import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.014 3.25h-.027a6.86 6.86 0 00-6.736 6.74v.004a6.617 6.617 0 003.333 5.83v1.51c0 1.15.933 2.083 2.083 2.083h.64v1.25a.75.75 0 101.5 0v-1.25h.527c1.15 0 2.083-.933 2.083-2.084v-1.51A6.617 6.617 0 0018.75 9.99v-.003a6.86 6.86 0 00-6.736-6.737zm1.903 12.833h-3.833v1.25c0 .323.261.584.583.584h2.667a.583.583 0 00.583-.584v-1.25zm-1.166-1.5v-2.272l1.78-1.78a.75.75 0 10-1.06-1.061L12 10.94l-1.47-1.47a.75.75 0 10-1.06 1.06l1.78 1.78v2.273H9.44a5.117 5.117 0 01-2.69-4.568A5.36 5.36 0 0112 4.75a5.36 5.36 0 015.25 5.262 5.117 5.117 0 01-2.69 4.571h-1.81z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
